function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 5,
  fill: "#bc002d"
});

function SvgJp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojYmMwMDJkO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSIxMCIgY3k9IjEwIiByPSI1Ii8+PC9zdmc+";
export { SvgJp as ReactComponent };